import api from './api';

export interface Broker {
  id: number;
  name: string;
  mobile: string;
  address?: string;
  projectId: number;
  project?: {
    id: number;
    name: string;
  };
  createdAt: string;
  updatedAt: string;
  createdBy?: string;
  updatedBy?: string;
}

export interface CreateBrokerData {
  name: string;
  mobile: string;
  address?: string;
  projectId: number;
}

class BrokerService {
  async getBrokers(params?: {
    page?: number;
    limit?: number;
    search?: string;
    projectId?: number;
  }): Promise<{
    brokers: Broker[];
    total: number;
    totalPages: number;
    page: number;
    limit: number;
  }> {
    const searchParams = new URLSearchParams();
    
    if (params?.page) searchParams.append('page', params.page.toString());
    if (params?.limit) searchParams.append('limit', params.limit.toString());
    if (params?.search) searchParams.append('search', params.search);
    if (params?.projectId) searchParams.append('projectId', params.projectId.toString());

    const response = await api.get(`/brokers?${searchParams.toString()}`);
    return {
      brokers: response.data.brokers,
      total: response.data.pagination.total,
      totalPages: response.data.pagination.pages,
      page: response.data.pagination.page,
      limit: response.data.pagination.limit
    };
  }

  async createBroker(data: CreateBrokerData): Promise<Broker> {
    const response = await api.post('/brokers', data);
    return response.data;
  }

  async getBroker(id: number): Promise<Broker> {
    const response = await api.get(`/brokers/${id}`);
    return response.data;
  }

  async updateBroker(id: number, data: CreateBrokerData): Promise<Broker> {
    const response = await api.put(`/brokers/${id}`, data);
    return response.data;
  }

  async deleteBroker(id: number): Promise<void> {
    await api.delete(`/brokers/${id}`);
  }
}

export const brokerService = new BrokerService();
